<template>
  <SwitchGroup as="div" class="flex items-center justify-between">
    <Switch v-model="enabled"
            class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-4"
            :class="{
              'bg-gray-200': !enabled,
              'bg-indigo-600': enabled
            }">
      <span aria-hidden="true"
            class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 translate-x-0"
            :class="{
              'translate-x-5': enabled
            }"
            />
    </Switch>
    <div class="flex-grow flex flex-col">
      <SwitchLabel as="span" class="text-sm font-medium text-gray-900" passive v-if="showLabel">{{ displayLabel }}</SwitchLabel>
      <SwitchDescription as="span"
                         class="text-sm text-gray-500"
                         v-if="description">{{ description }}</SwitchDescription>
      <p v-if="error" class="mt-2 text-sm text-red-600">{{ error }}</p>
    </div>
  </SwitchGroup>

</template>

<script>
import { Switch, SwitchDescription, SwitchGroup, SwitchLabel } from '@headlessui/vue'
import FormCommon from './form-mixin'

export default {
  components: {
    Switch,
    SwitchDescription,
    SwitchGroup,
    SwitchLabel,
  },

  mixins: [
    FormCommon,
  ],

  props: {
    modelValue: Boolean,
    description: String,
    showLabel: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      enabled: this.modelValue,
    }
  },

  watch: {
    enabled(newValue) {
      this.$emit('update:modelValue', newValue)
    },
  },
}
</script>
